import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import {inject} from 'mobx-react';
import {EDIT_TUTORIAL_TYPE, DELETE_TUTORIAL_TYPE} from 'constants/adminPupups';

@inject('editableCategoryStore')
export default class extends React.Component {

  static propTypes = {
    placeholder: PropTypes.object,
    title: PropTypes.string,
    time: PropTypes.string,
    isAdmin: PropTypes.bool,
    type: PropTypes.object
  };

  static defaultProps = {
    locked: false,
    played: false,
    type: null,
    viewed: false
  };

  state = {
    isActive: false
  };

  handleIcon = () => {
    const {locked, played} = this.props;
    if (locked) {
      return (<div className="video-icon ic-lock"/>)
    }
    else if (played) {
      return (<div className="video-icon ic-play"/>)
    }
  };

  handleOpenPanel(e) {
    e.stopPropagation();
    e.preventDefault();
    this.setState({isActive: true})
  }

  handleClosePanel(e) {
    e.preventDefault();
    this.setState({isActive: false})
  }

  handleEdit = (e) => {
    e.preventDefault();
    this.props.editableCategoryStore.activate(EDIT_TUTORIAL_TYPE, this.props.itemId)
  };

  handleDelete = (e) => {
    e.preventDefault();
    this.props.editableCategoryStore.activate(DELETE_TUTORIAL_TYPE,
      {categoryId: this.props.categoryId, itemId: this.props.itemId})
  };

  openPopupLanding = () => {
    this.props.openPopupLanding(this.props.url)
  };

  handleCategoryHolder = () => {
    const {type, viewed, isAdmin} = this.props;
    const {isActive} = this.state;
    if (isAdmin) {
      return (
        <div
          onClick={this.handleClosePanel.bind(this)}
          className={classNames('video-category-holder', {'active': isActive})}>
          <div className='video-admin-panel'>
            <i
              onClick={this.handleOpenPanel.bind(this)}
              className="video-admin-menu ic-ellipsis"
            />
            <div className="video-admin-inner">
              <div className="video-admin-icon" onClick={this.handleEdit}>
                <i className="ic ic-edit"/>
              </div>
              <div className="video-admin-icon" onClick={this.handleDelete}>
                <i className="ic ic-close-circle"/>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      if (type && viewed) {
        return (
          <div className="video-category-holder">
            <Link to={type.url || ''} className="video-type">{type.name}</Link>
            <div className="video-viewed">VIEWED</div>
          </div>
        )
      }

      if (type) {
        return (
          <div className="video-category-holder">
            <Link to={type.url || ''} className="video-type">{type.name}</Link>
          </div>
        )
      } else if (viewed) {
        return (
          <div className="video-category-holder">
            <div className="video-viewed">VIEWED</div>
          </div>
        )
      }
    }
  };

  render() {
    const {placeholder, time, title} = this.props;
    const icon = this.handleIcon();
    const categoryHolder = this.handleCategoryHolder();

    return (
      <div className="video-item">
        <img className="video-placeholder" src={placeholder.img}/>
        <div className="video-inner"  onClick={this.props.isLanding && this.openPopupLanding}>
          {categoryHolder}
          {icon}
          <div className="video-additional-info">
            <div className="video-title">
              {title}
            </div>
            <div className="video-time">{time}</div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/components/videoPreview.jsx